<div [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize  : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group" style="display: inline-block; margin-right:20px;">
  <!-- <mat-label>{{field.label}}</mat-label> -->
  <mat-slide-toggle [formControlName]="field.name" color="primary" [matTooltip]="field.hint"
    [matTooltipDisabled]="!field.hint" matTooltipPosition="above" matTooltipClass="sbm-tooltip">
    <app-required *ngIf="isRequired()"></app-required>
    <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
    {{field.label}}
  </mat-slide-toggle>
  <mat-error *ngIf="group.get(field.name).touched && group.get(field.name).hasError('required')">
    This should be enabled.
  </mat-error>
</div>
